import ModalDialog, {
  ModalCloseHandler,
  ModalCloseReason,
} from 'src/components/ModalDialog';
import { useForm } from 'src/components/Form';
import { useAlert, AlertType } from 'src/components/AlertsProvider';
import { pepApiRequest, RequestMethod, useStatefulApi } from 'src/services';
import { generatePath, useParams } from 'react-router-dom';
import { CompanyUserItem } from '../../types';
import { API_COMPANY_USERS } from '../../constants';
import { companyUserAssignFormFields } from '../formFields';

type Props = {
  item: CompanyUserItem;
  open: boolean;
  onClose: ModalCloseHandler;
};

function CompanyUsersAssignModal({ item, open, onClose }: Props) {
  const { showAlert } = useAlert();
  const { companyId } = useParams();

  const [onSubmit, loading] = useStatefulApi(
    (params) =>
      pepApiRequest({
        method: RequestMethod.Post,
        url: generatePath(API_COMPANY_USERS, { companyId }),
        params,
      }),
    () => {
      showAlert({
        type: AlertType.Success,
        title: 'Company user assigned',
        text: 'Company user has been successfully assigned.',
      });
      onClose(null, ModalCloseReason.completeAction);
    }
  );

  const [form, handleSubmit] = useForm({
    fields: companyUserAssignFormFields,
    values: item,
    onSubmit,
  });

  return (
    <ModalDialog
      open={open}
      title="Assign user"
      loading={loading}
      onClose={onClose}
      onConfirm={handleSubmit}
      confirmBtnText="Assign"
    >
      {form}
    </ModalDialog>
  );
}

export default CompanyUsersAssignModal;
